import { useSelector } from "react-redux";
import { selectorSystemLoaders } from "../store/system/selectors";

export const useLoaderById = (idOrIds) => {
  const loaderIds = useSelector(selectorSystemLoaders);
  return loaderIds.some((l) => l === idOrIds);
};
